module.exports = __webpack_public_path__ + "img/foodlocker.cb3fc2f0.svg";